import { all, call, fork, put, takeLatest } from "typed-redux-saga";
import { Action, ncsColorActions } from "./ncs-colors-store";
import { errorActions as errorActions } from "src/components/error-viewer/error-store";
import { NcsColorService } from "src/backend/openapi/v1";

// the picker only ever dispatches the request action once its own Loading<T> hasn't started,
// so takeLatest here is just the standard read-saga convention rather than a de-dupe mechanism
export function* getNcsColorsRequest() {
  try {
    const result = yield* call(NcsColorService.getApiV1NcsColors);
    yield put(ncsColorActions.getNcsColorsSuccess(result));
  } catch (error) {
    yield put(errorActions.addError(error));
    yield put(ncsColorActions.getNcsColorsFailure());
  }
}

export function* watchGetNcsColorsRequest() {
  yield takeLatest(Action.GetNcsColorsRequest, getNcsColorsRequest);
}

export function* ncsColorsSaga() {
  yield all([fork(watchGetNcsColorsRequest)]);
}
